module.exports = __webpack_public_path__ + "dca153a54bdd95cecf72c86826203fc9.png";